<template>
  <div class="ranking">
    <Header
      v-bind:pageName="pageName"
      v-bind:login="login"
      v-bind:profile="profile"
      v-bind:loading="loading"
      @profile="profile = $event"
      v-bind:mai="mai"
      @mai="mai = $event"
    />
    <Loading v-if="loading" />
    <div v-else>
      <h2>ランキング機能は準備中だよ(&gt; &lt;)</h2>
      <RankContinue v-if="!preparation" />
      <RankPoint v-if="!preparation" />
      <RankMai v-if="!preparation" />
      <RankNew
        v-if="preparation"
        v-bind:uid="user.uid"
        v-bind:uname="profile.name"
      />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/modules/header";
import Loading from "@/components/parts/Loading";
import RankContinue from "@/components/modules/RankContinue";
import RankPoint from "@/components/modules/RankPoint";
import RankMai from "@/components/modules/RankMai";
import RankNew from "@/components/modules/RankNew";

import firebaseUtil from "@/firebase";
import store from "@/store";

export default {
  data() {
    return {
      pageName: "応援する",
      login: false,
      user: {},
      provider: {},
      profile: {},
      mai: {},
      loading: true,
      preparation: true,
    };
  },
  components: {
    Header,
    Loading,
    RankContinue,
    RankPoint,
    RankMai,
    RankNew,
  },
  created() {
    let myPromise1 = new Promise((resolve) => {
      firebaseUtil.onAuth("ranking").then(() => {
        resolve();
      });
    });
    myPromise1.then(() => {
      this.user = store.getters.user;
      console.log(this.user);
      if (!this.user.state) {
        this.user = "";
        this.loading = false;
      } else {
        for (let i = 0; i < this.user.providerData.length; i++) {
          if (this.user.providerData[i].providerId == "twitter.com") {
            this.provider.twitter = true;
          } else {
            this.provider.google = true;
          }
        }
        this.login = true;
        this.loading = false;
      }
    });
  },
  computed: {
    profileWatch() {
      return this.profile;
    },
  },
  watch: {
    profileWatch(data) {
      console.log(data);
    },
  },
};
</script>

<style lang="scss">
.rank {
  &_continue,
  &_point,
  &_new {
    @include Section_padding();
    .continue {
      &_header {
        @include Section_header();
        flex-wrap: wrap;
      }
      &_toggle {
        @include fz(14);
        .toggle {
          margin: 10px;
          padding: 4px 16px;
          border: 1px solid #000;
          border-radius: 20px;
        }
      }
      &_list {
        margin-top: 60px;
        width: calc(100% + 9.2vw);
        margin-left: -4.6vw;
        overflow: auto hidden;
        padding: 0 4.6vw;
        &.column {
          display: grid;
          grid-template-columns: repeat(auto-fit, 246px);
          grid-gap: 20px;
        }
        &.slider {
          display: flex;
          .item {
            width: 246px;
            min-width: 246px;
            margin-right: 20px;
          }
        }
        .item {
          width: 246px;
          min-width: 246px;
          padding: 20px;
          background-color: #aaa;
          border-radius: 4px;
          position: relative;
          &_title {
            @include fz(16);
          }
          &_div {
            text-align: center;
            @include challenge_graph(160px, 24, 18);
            margin: 20px auto;
          }
          &_btn_cheer {
            @include cheer_btn();
            position: relative;
            margin: 0 auto;
          }
          &_btn_chip {
            @include icon(40px);
            position: absolute;
            right: 0;
            bottom: 24px;
          }
        }
        @include sp {
          width: 104%;
          margin-left: -2%;
          margin-top: 0;
          padding: 20px 0;
          &.column {
            justify-content: center;
          }
        }
      }
    }
    .point,
    .new {
      &_header {
        @include Section_header();
        flex-wrap: wrap;
      }
      &_toggle {
        @include header_toggle();
      }
      &_list {
        margin-top: 60px;
        width: calc(100% + 9.2vw);
        margin-left: -4.6vw;
        overflow: auto hidden;
        padding: 0 4.6vw;
        &.column {
          display: grid;
          grid-template-columns: repeat(auto-fit, 246px);
          grid-gap: 20px;
        }
        &.slider {
          display: flex;
          .item {
            width: 246px;
            min-width: 246px;
            margin-right: 20px;
          }
        }
        .item {
          width: 246px;
          min-width: 246px;
          padding: 20px;
          background-color: #fff;
          box-shadow: $btn_shadow;
          border-radius: 4px;
          position: relative;
          .graph_img {
            height: 100%;
            width: 100%;
            left: 0;
            top: 0;
          }
          &_title {
            margin: 0 auto;
            @include fz(16);
            @include text_overflow(2);
            @include pc {
              &:hover {
                text-decoration: underline;
              }
            }
          }
          &_div {
            text-align: center;
            @include challenge_graph(160px, 24, 18);
            margin: 20px auto;
          }
          &_btn_cheer {
            @include cheer_btn();
            position: relative;
            margin: 0 auto;
          }
          &_btn_chip {
            @include icon(40px);
            position: absolute;
            right: 0;
            bottom: 24px;
          }
        }
        @include sp {
          width: 104%;
          margin-left: -2%;
          margin-top: 0;
          padding: 20px 0;
          &.column {
            justify-content: center;
          }
        }
      }
    }
  }
  &_mai {
    @include Section_padding();
    .mai {
      &_header {
        @include Section_header();
        flex-wrap: wrap;
      }
      &_toggle {
        @include fz(14);
        .toggle {
          margin: 10px;
          padding: 4px 16px;
          border: 1px solid #000;
          border-radius: 20px;
        }
      }
      &_list {
        margin-top: 60px;
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));
        grid-gap: 20px;
        .item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 10px 20px;
          background: #aaa;
          border-radius: 4px;
          &_status_user {
            display: grid;
            align-items: center;
            grid-template-areas:
              "a b"
              "a c";
            grid-column-gap: 10px;
            .user {
              &_icon {
                grid-area: a;
                @include icon(40px);
                border: 2px solid $bg_accent;
                background-color: #fff;
              }
              &_name {
                grid-area: b;
                @include fz(16);
                align-self: start;
                max-width: 120px;
                min-width: 84px;
                overflow: hidden;
              }
              &_status {
                grid-area: c;
                @include fz(12);
                align-self: start;
                max-width: 120px;
                min-width: 84px;
                overflow: hidden;
              }
            }
          }
        }
        @include sp {
          grid-template-columns: 1fr;
        }
      }
    }
  }
}
</style>